var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", staticStyle: { "flex-grow": "1" } },
    [
      _c(
        "customer-vendor-rating-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.subscribedPaidCapital &&
          _vm.elementDict.subscribedPaidCapital.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "subscribedPaidCapital" },
                  slot: "subscribedPaidCapital"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.subscribedPaidCapital.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.subscribedPaidCapital.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.subscribedPaidCapital,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.subscribedPaidCapital.writable,
                        clearable: "",
                        no: "subscribedPaidCapital"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.subscribedPaidCapital = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.CAPITAL_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxpayerCreditLevel &&
          _vm.elementDict.taxpayerCreditLevel.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "taxpayerCreditLevel" },
                  slot: "taxpayerCreditLevel"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxpayerCreditLevel.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxpayerCreditLevel.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.taxpayerCreditLevel,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.taxpayerCreditLevel.writable,
                        clearable: "",
                        no: "taxpayerCreditLevel"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.taxpayerCreditLevel = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.TAX_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.enterpriseNature &&
          _vm.elementDict.enterpriseNature.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "enterpriseNature" },
                  slot: "enterpriseNature"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.enterpriseNature.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.enterpriseNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.enterpriseNature,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.enterpriseNature.writable,
                        clearable: "",
                        no: "enterpriseNature"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.enterpriseNature = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.NATURE_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.businessPremisesNature &&
          _vm.elementDict.businessPremisesNature.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "businessPremisesNature" },
                  slot: "businessPremisesNature"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.businessPremisesNature.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.businessPremisesNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.businessPremisesNature,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.businessPremisesNature.writable,
                        clearable: "",
                        no: "businessPremisesNature"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.businessPremisesNature = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.VENUE_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cooperationYearsContinuity &&
          _vm.elementDict.cooperationYearsContinuity.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "cooperationYearsContinuity" },
                  slot: "cooperationYearsContinuity"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cooperationYearsContinuity.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cooperationYearsContinuity.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.cooperationYearsContinuity,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.cooperationYearsContinuity.writable,
                        clearable: "",
                        no: "cooperationYearsContinuity"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.cooperationYearsContinuity = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.COOP_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedReceivableDays &&
          _vm.elementDict.estimatedReceivableDays.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "estimatedReceivableDays" },
                  slot: "estimatedReceivableDays"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedReceivableDays.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedReceivableDays.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.estimatedReceivableDays,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.estimatedReceivableDays.writable,
                        clearable: "",
                        no: "estimatedReceivableDays"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.estimatedReceivableDays = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.AR_DAYS_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedMonthlyAmount &&
          _vm.elementDict.estimatedMonthlyAmount.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "estimatedMonthlyAmount" },
                  slot: "estimatedMonthlyAmount"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedMonthlyAmount.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedMonthlyAmount.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.estimatedMonthlyAmount,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.estimatedMonthlyAmount.writable,
                        clearable: "",
                        no: "estimatedMonthlyAmount"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.estimatedMonthlyAmount = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.AR_AMT_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedGrossProfitContribution &&
          _vm.elementDict.estimatedGrossProfitContribution.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "estimatedGrossProfitContribution" },
                  slot: "estimatedGrossProfitContribution"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedGrossProfitContribution
                      .isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.estimatedGrossProfitContribution.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.estimatedGrossProfitContribution,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.estimatedGrossProfitContribution
                            .writable,
                        clearable: "",
                        no: "estimatedGrossProfitContribution"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.estimatedGrossProfitContribution = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.MARGIN_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerNature &&
          _vm.elementDict.customerNature.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "customerNature" },
                  slot: "customerNature"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerNature.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.customerNature,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.customerNature.writable,
                        clearable: "",
                        no: "customerNature"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.customerNature = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.CUSTOMER_TYPE_LIST, function(
                      item
                    ) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.industryExtraQualificationsAwards &&
          _vm.elementDict.industryExtraQualificationsAwards.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "industryExtraQualificationsAwards" },
                  slot: "industryExtraQualificationsAwards"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.industryExtraQualificationsAwards
                      .isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.industryExtraQualificationsAwards.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.industryExtraQualificationsAwards,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.industryExtraQualificationsAwards
                            .writable,
                        clearable: "",
                        no: "industryExtraQualificationsAwards"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.industryExtraQualificationsAwards = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.QUALITY_LIST, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.totalScore &&
                    _vm.elementDict.totalScore.viewable,
                  expression:
                    "elementDict.totalScore && elementDict.totalScore.viewable"
                }
              ],
              key: "totalScore",
              attrs: { slot: "totalScore" },
              slot: "totalScore"
            },
            [
              _vm.elementDict.totalScore && _vm.elementDict.totalScore.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        width: "calc(25% - 15px)",
                        "margin-right": "10px"
                      },
                      attrs: { slot: "totalScore" },
                      slot: "totalScore"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.totalScore.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.totalScore.label
                        },
                        slot: "label"
                      }),
                      _c("auto-number-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "totalScore",
                          precision: 0,
                          min: 0,
                          disabled: true
                        },
                        model: {
                          value: _vm.form.totalScore,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "totalScore", $$v)
                          },
                          expression: "form.totalScore"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.elementDict.totalScore &&
                  _vm.elementDict.totalScore.viewable,
                expression:
                  "elementDict.totalScore && elementDict.totalScore.viewable"
              }
            ],
            key: "totalScore1",
            staticStyle: {
              "background-color": "rgb(230 227 228)",
              height: "2px"
            },
            attrs: { slot: "totalScore" },
            slot: "totalScore"
          }),
          _vm.elementDict.procurementType &&
          _vm.elementDict.procurementType.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "procurementType" },
                  slot: "procurementType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.procurementType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.procurementType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.procurementType,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.procurementType.writable,
                        clearable: "",
                        no: "procurementType"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.procurementType = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.PROCUREMENT_TYPE_LIST, function(
                      item
                    ) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.supplierQuotation &&
          _vm.elementDict.supplierQuotation.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "supplierQuotation" },
                  slot: "supplierQuotation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.supplierQuotation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.supplierQuotation.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "supplierQuotation",
                      precision: 2,
                      min: 0,
                      disabled: _vm.readonly
                    },
                    model: {
                      value: _vm.form.supplierQuotation,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supplierQuotation", $$v)
                      },
                      expression: "form.supplierQuotation"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.intendedSupplier &&
          _vm.elementDict.intendedSupplier.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(25% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "intendedSupplier" },
                  slot: "intendedSupplier"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.intendedSupplier.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.intendedSupplier.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.form.intendedSupplier,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.intendedSupplier.writable,
                        clearable: "",
                        no: "intendedSupplier"
                      },
                      on: {
                        input: function(val) {
                          _vm.form.intendedSupplier = val
                        },
                        change: _vm.dataChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.YESORNO_COMMON_STATES, function(
                      item
                    ) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: Boolean(item.code)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }